// extracted by mini-css-extract-plugin
export var card = "_mh-0";
export var content = "_mh-2";
export var details = "_mh-3";
export var icon = "_mh-1";
export var iconBlue = "_mh-5";
export var iconBrand = "_mh-4";
export var iconGrayBlue = "_mh-6";
export var iconGreen = "_mh-7";
export var iconIndigo = "_mh-8";
export var iconOrange = "_mh-9";
export var iconPurple = "_mh-a";
export var iconRed = "_mh-b";
export var iconWarning = "_mh-c";